/*
	MUSICPLAYER.JS
*/

var currentEvent = null;
var mouseDown = false;
var audios = [];
var audioPlaying = -1;
var originPlaying = -1;
var fullLineLenght = 0;

var audioAmount = 0;
var audioAmountMini = 0;
var audioAmountSnapshots = 0;

$(document).ready( function() {
	audioAmount = $('.audio-demo').length;
	audioAmountMini = $('.audio-demo-mini').length;
	audioAmountSnapshots = $('.audio-demo-snapshot').length;
	let currentID;

	$(".audio-line").on('mousedown', function(e) {
		updateLineClick(e);
		mouseDown = true;
	});
	$(document).on('mousemove', function(e) {
		if(mouseDown) {
			updateLineClick(e);
		}
	});
	$(document).on('mouseup', function() {
		mouseDown = false;
	});
	$(".audio-logo").on('click', function(e) {
		// currentID = isNaN(e.target.id.slice(-3))? e.target.id.slice(-1) : e.target.id.slice(-2);
		currentID = e.target.id.match(/\d+$/)[0];

		playAudio(currentID);
	});	

	$(".audio-logo-mini").on('click', function(e) {
		// currentID = isNaN(e.target.id.slice(-4))? e.target.id.slice(-1) : e.target.id.slice(-2);
		currentID = e.target.id.match(/\d+$/)[0];

		dataID = $(this).data('id');
		originID = currentID;
		if(dataID !== undefined)
			currentID = dataID + 100;
		playAudio(currentID, originID);
		if(currentID >= 100) {
			loadSliderAnimation(currentID);
			initUI();
		}
	});	



	$(window).on('resize', function() {
		if($('#audio-progress-remaining-0')) {
			fullLineLength = $('#audio-progress-remaining-0').get(0).getBoundingClientRect().width;
			updateLineResize();
		}
	});
	fullLineLength = $('#audio-progress-remaining-0').get(0).getBoundingClientRect().width;
	
	initAudios();
});


function updateLineClick(e) {
	var rect = $('#audio-progress-remaining-0').get(0).getBoundingClientRect();
	var mousePosition = e.clientX - rect.left;
	var id = isNaN(e.target.id.slice(-3))? e.target.id.slice(-1) : e.target.id.slice(-2);
	var percentage = mousePosition / fullLineLength;
	var newLength = (mousePosition > fullLineLength)? fullLineLength : mousePosition;
	$('#audio-progress-done-'+id).css({"width":newLength+"px"});
	if(percentage > 0.995) {
		$('#audio-progress-done-'+id).addClass('audio-progress-done-full');
	} else if($('#audio-progress-done-'+id).hasClass('audio-progress-done-full')) {
		$('#audio-progress-done-'+id).removeClass('audio-progress-done-full');
	}
	audios[id].currentTime = audios[id].duration * percentage;
	document.getElementById('audio-current-duration-'+id).innerHTML = durationString(audios[id].currentTime);
}

function updateLinePlay() {
	if(audioPlaying <= 10) {
		var percentage = audios[audioPlaying].currentTime / audios[audioPlaying].duration;
		newLength = fullLineLength * percentage;
		$('#audio-progress-done-'+audioPlaying).css({"width":newLength+"px"});
	}
}

function updateLineResize() {
	for(i=0;i<audioAmount;i++) {
		percentage = audios[i].currentTime / audios[i].duration;
		newLength = fullLineLength * percentage;
		$('#audio-progress-done-'+i).css({"width":newLength+"px"});
	}
}

function loadAudio(url, vol, id, type='main') {
	var audio = new Audio();
	audio.type = "audio/mp3";
	audio.src = url;
	audio.preload = "auto";
	audio.volume = vol;
	$(audio).on("loadedmetadata", function(){
		if(id < 10 && type == 'main') {
       		refreshMaxDuration(audio.duration, id);
       	}
    });
	// $(audio).on("loadeddata", launchApp);  // jQuery checking
	return audio;
}

// 0 TO 9: REGULAR AUDIO
// 10+: MINI AUIDOS
function initAudios() {
	for(i=0;i<audioAmount;i++) {
		if(instrument == 'mallets') {
			audios[i] = loadAudio('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/'+instrument+'-demo-'+i+'.mp3?v=1780146860', 1, i, 'main');
		} else  {
			audios[i] = loadAudio('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/'+instrument+'-demo-'+i+'.mp3', 1, i, 'main');
		}
	}
	for(i=10;i<audioAmountMini+10;i++) {
		audios[i] = loadAudio('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/'+instrument+'-demo-mini-'+i+'.mp3?v=123122', 1, i, 'mini');
	}

	for(i=30;i<audioAmountSnapshots+10;i++) {
		audios[i] = loadAudio('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/'+instrument+'-demo-snapshot-'+i+'.mp3', 1, i, 'mini');
	}

	// GUI AUDIOS
	if(typeof GUI_InfoTrackTitles !== 'undefined' && typeof GUI_InfoTrackTitles[instrument] !== 'undefined') {
		for(i=0;i<GUI_InfoTrackTitles[instrument].length;i++) {
			for(j=0;j<GUI_InfoTrackTitles[instrument][i].length;j++) {
				if(GUI_InfoTrackTitles[instrument][i][j] != '')
					audios[100 + i*10 + j] = loadAudio('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/'+instrument+'-demo-gui-'+(i*10 + j)+'.mp3', 1, i, 'gui');
			}
		}
	}
}



function playAudio(id, originID = id) {
    if (audioPlaying == -1) {
    	if(id >= 10)
    		audios[id].currentTime = 0;
        audios[id].play();
        audioPlaying = id;
        originPlaying = originID;
        // document.getElementById('audio-logo-image-'+id).isNaNerHTML = 'PAUSE';
        document.getElementById("audio-logo-image-" + originID).style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/button_pause_nocircle_s.png')";
        refreshAudio();
    } else if (audioPlaying == id) {
        audios[audioPlaying].pause();
        // document.getElementById('audio-logo-image-'+id).innerHTML = 'PLAY';
        document.getElementById("audio-logo-image-" + originID).style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/button_play_nocircle_s.png')";
        audioPlaying = -1;
        originPlaying = -1;
    } else {
        audios[audioPlaying].pause();
        if(id >= 10)
    		audios[id].currentTime = 0;
        // document.getElementById('audio-logo-image-'+audioPlaying).innerHTML = 'PLAY';
        document.getElementById("audio-logo-image-" + originPlaying).style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/button_play_nocircle_s.png')";
        audios[id].play();
        // document.getElementById('audio-logo-image-'+id).innerHTML = 'PAUSE';
        document.getElementById("audio-logo-image-" + originID).style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/button_pause_nocircle_s.png')";
        audioPlaying = id;
        originPlaying = originID;
    }
}

function durationString(duration) {
	var minutes = Math.floor(duration / 60);
	var seconds = Math.floor(duration) - minutes * 60;
	var secondsString = (seconds < 10)? "0"+seconds : ""+seconds;
	return minutes+":"+secondsString;
}

function refreshMaxDuration(duration, id) {
	if(document.getElementById('audio-max-duration-'+id))
		document.getElementById('audio-max-duration-'+id).innerHTML = durationString(duration);
}

function refreshAudio() {
	if(audioPlaying > -1) {
		audios[audioPlaying].currentTime;

		// MAKE SURE THE AUDIO PLAYING IS BELOW 10 (NO MINI AUDIO)
		if(audioPlaying < 10)
			document.getElementById('audio-current-duration-'+audioPlaying).innerHTML = durationString(audios[audioPlaying].currentTime);
		updateLinePlay();
		if(audios[audioPlaying].currentTime < audios[audioPlaying].duration)
			window.requestAnimationFrame(refreshAudio);
		else {
			document.getElementById("audio-logo-image-" + originPlaying).style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/button_play_nocircle_s.png')";
			audioPlaying = -1;
			originPlaying = -1;
		}
	}
}

